import { useEffect, useState } from "react";
import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";
import { KineticLines } from "@/components/Motion";
import { IndustryCard } from "@/components/Cards";
import CTASection from "@/components/CTASection";
import api from "@/lib/api";

export default function Industries() {
  const [industries, setIndustries] = useState([]);
  useEffect(() => { api.get("/industries").then((r) => setIndustries(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="industries-page">
      <SEO title="Industries" path="/industries"
        description="STJ Innovations serves pharmaceutical, biotechnology, medical device, healthcare, laboratory, food & nutraceutical and electronics industries with cleanroom equipment and precision fabrication." />
      <section className="blueprint-dark bg-ink">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
          <Breadcrumbs dark items={[{ label: "Industries" }]} />
          <p className="eyebrow eyebrow-light">Industries</p>
          <KineticLines lines={["Solutions Across", "Critical Industries"]}
            className="mt-5 font-display text-4xl font-medium leading-[1.06] tracking-tight text-white sm:text-5xl" />
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-400">
            Environments where contamination control, cleanability and reliability are non-negotiable — each with its own engineering requirements.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-24">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="industries-grid">
          {industries.map((ind, i) => <IndustryCard key={ind.slug} industry={ind} index={i} />)}
        </div>
      </section>
      <CTASection />
    </div>
  );
}
